import React, { useRef } from "react";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import { useCurrentUser } from "../../auth/use-currentUser";
import { Permissions } from "../../auth/permissions";
import { logout } from "../../auth/session";
import { useNavigateApp } from "../../hooks/use-navigateApp";
import {
  UserButton,
  UserName,
  MenuHeader,
  MenuHeaderName,
  MenuHeaderEmail,
  MenuHeaderRoles,
} from "./UserMenu.styles";

const UserMenu: React.FC = () => {
  const { user, can } = useCurrentUser();
  const { navigateTo } = useNavigateApp();
  const menuRef = useRef<Menu>(null);

  if (!user) return null;

  const canAdminister = can(Permissions.UsersManage) || can(Permissions.RolesManage);
  const displayName = user.ssoEnabled
    ? user.name || user.email || "Пользователь"
    : "Вход отключён";

  const items: MenuItem[] = [
    {
      template: () => (
        <MenuHeader>
          <MenuHeaderName>{displayName}</MenuHeaderName>
          {user.email && user.email !== displayName && (
            <MenuHeaderEmail>{user.email}</MenuHeaderEmail>
          )}
          {user.roles.length > 0 && (
            <MenuHeaderRoles>{user.roles.join(", ")}</MenuHeaderRoles>
          )}
        </MenuHeader>
      ),
    },
  ];

  if (canAdminister) {
    items.push({ separator: true });
    items.push({
      label: "Администрирование",
      icon: "pi pi-users",
      command: () => navigateTo("admin"),
    });
  }

  if (user.ssoEnabled) {
    items.push({ separator: true });
    items.push({ label: "Выйти", icon: "pi pi-sign-out", command: logout });
  }

  return (
    <>
      <Menu model={items} popup ref={menuRef} style={{ width: "auto", minWidth: "15rem" }} />
      <UserButton
        type="button"
        aria-label="Меню пользователя"
        aria-haspopup
        title={user.email ?? displayName}
        onClick={(e) => menuRef.current?.toggle(e)}
      >
        <i className="pi pi-user" aria-hidden="true" />
        <UserName>{displayName}</UserName>
      </UserButton>
    </>
  );
};

export default UserMenu;
